import React from 'react'
import PropTypes from 'prop-types'
import { Container } from '@chakra-ui/react'

ContainerContent.propTypes = {
  children: PropTypes.node,
  rest: PropTypes.any,
}

function ContainerContent({ children, ...rest }) {
  return (
    <Container
      maxW={768}
      position="relative"
      {...rest}>
      {children}
    </Container>
  )
}

export default ContainerContent
